export const API_URL = 'https://api.amco.pt/api';
export const X_Access_Token = '@amco-Token';